const jobs = [
  {
    id: 1,
    title: "Frontend Developer",
    company: "Tech Solutions Inc.",
    category: "Frontend",
    description:
      "We are seeking a skilled frontend developer to craft intuitive and responsive web interfaces. The role involves working with modern JavaScript frameworks like React. You’ll collaborate closely with backend developers and designers. Strong attention to detail and a good eye for UI are essential.",
    salary: "₹8 LPA",
    requirements: "2+ years of experience, React, JavaScript, CSS",
  },
  {
    id: 2,
    title: "Backend Developer",
    company: "Cloudify",
    category: "Backend",
    description:
      "Join our backend team to build scalable APIs and manage databases. You’ll work on Node.js and MongoDB, ensuring security and performance. The role includes integrating third-party services and automating workflows. Experience with RESTful services is a must.",
    salary: "₹10 LPA",
    requirements: "3+ years of experience, Node.js, Express, MongoDB",
  },
  {
    id: 3,
    title: "Full Stack Engineer",
    company: "InnovateX",
    category: "Full Stack",
    description:
      "We are hiring a full stack engineer to handle end-to-end web development. The candidate should be equally comfortable in frontend and backend. You’ll work on building features, fixing bugs, and optimizing performance. Prior experience with the MERN stack is preferred.",
    salary: "₹12 LPA",
    requirements: "Full stack experience, React, Node.js, SQL",
  },
  {
    id: 4,
    title: "UI/UX Designer",
    company: "DesignGrid",
    category: "Design",
    description:
      "DesignGrid is looking for a creative UI/UX designer to improve our product usability. You’ll be responsible for wireframing, prototyping, and delivering final mockups. You should have a strong understanding of design principles and user behavior. Familiarity with Figma and Adobe XD is required.",
    salary: "₹7 LPA",
    requirements: "1+ year of experience, Figma, Adobe XD, Sketch",
  },
  {
    id: 5,
    title: "DevOps Engineer",
    company: "DeployNow",
    category: "DevOps",
    description:
      "As a DevOps engineer, you’ll automate and maintain our cloud infrastructure. Responsibilities include CI/CD setup, Docker container management, and system monitoring. You will work closely with developers to ensure smooth deployments. Hands-on experience with AWS and Jenkins is crucial.",
    salary: "₹14 LPA",
    requirements: "AWS, Docker, CI/CD pipelines, Jenkins",
  },
  {
    id: 6,
    title: "Mobile App Developer",
    company: "Appify",
    category: "Mobile",
    description:
      "We are looking for a mobile developer with expertise in Flutter to build cross-platform apps. You’ll be responsible for app performance, UI development, and API integration. The ideal candidate should be passionate about mobile technologies and trends. Experience with Firebase is a plus.",
    salary: "₹9 LPA",
    requirements: "Dart, Flutter, Firebase, REST APIs",
  },
  {
    id: 7,
    title: "Data Analyst",
    company: "InsightWorks",
    category: "Data Science",
    description:
      "InsightWorks is hiring a data analyst to extract insights from large datasets. You’ll work on creating dashboards, reports, and visualizations. Strong command over SQL and Python is required. Experience with BI tools like Tableau or Power BI is preferred.",
    salary: "₹8.5 LPA",
    requirements: "SQL, Python, Power BI or Tableau, Excel",
  },
  {
    id: 8,
    title: "Machine Learning Engineer",
    company: "AI Revolution",
    category: "AI/ML",
    description:
      "Join our AI team to develop, train, and deploy ML models. You’ll be working on real-world problems using large datasets. Proficiency in Python and libraries like TensorFlow is needed. Familiarity with data preprocessing and model evaluation is essential.",
    salary: "₹15 LPA",
    requirements: "Python, TensorFlow, scikit-learn, data preprocessing",
  },
  {
    id: 9,
    title: "QA Engineer",
    company: "QualitySoft",
    category: "QA",
    description:
      "We’re looking for a QA engineer to ensure the quality of our software products. The role includes manual and automated testing, writing test cases, and reporting bugs. You’ll collaborate with developers to maintain product reliability. Knowledge of Selenium and Postman is expected.",
    salary: "₹7.5 LPA",
    requirements: "Manual testing, Selenium, Postman, Test cases",
  },
  {
    id: 10,
    title: "Product Manager",
    company: "BuildItRight",
    category: "Management",
    description:
      "As a Product Manager, you’ll own the product lifecycle from concept to launch. You’ll work closely with design, engineering, and marketing teams. A strong understanding of customer needs and Agile methodology is key. Prior experience leading cross-functional teams is essential.",
    salary: "₹18 LPA",
    requirements: "Agile, Product lifecycle, Communication, Leadership",
  },
  {
    id: 11,
    title: "Cloud Architect",
    company: "NimbusCloud",
    category: "Cloud",
    description:
      "We need a Cloud Architect to design secure and scalable cloud infrastructure. You’ll guide migration projects and review architectural decisions. The role involves cost optimization and automation. Experience with Kubernetes and multiple cloud platforms is preferred.",
    salary: "₹20 LPA",
    requirements: "AWS/GCP/Azure, Architecture design, Kubernetes",
  },
  {
    id: 12,
    title: "Cybersecurity Analyst",
    company: "SecureBase",
    category: "Security",
    description:
      "SecureBase is looking for a cybersecurity analyst to monitor and protect systems. You’ll handle threat detection, incident response, and vulnerability assessments. Knowledge of SIEM tools and firewalls is crucial. Certifications like CEH or CompTIA Security+ are a plus.",
    salary: "₹13 LPA",
    requirements: "SIEM tools, Network security, Threat analysis",
  },
];


export default jobs;
